export default __webpack_public_path__ + "static/media/partner-cdm.384e5c7e.png";